const sendGTMEvent = (eventObject) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({}, eventObject));
};
export default sendGTMEvent;
//# sourceMappingURL=sendGTMEvent.js.map